import React from 'react';

import TransportationSearchForm from './TransportationSearchForm';
import injectTransportationSearchParams from './injectTransportationSearchParams';
import { Sticky, StaticSearchFormWrapper } from '../../../components';
import { formatToShow } from '../../../lib/helpers';

const renderForDesktop = () => (
  <Sticky>
    <section className="sidebar_search d-none d-lg-block">
      <h4>Search</h4>
      <TransportationSearchForm />
    </section>
  </Sticky>
);

const renderForMobile = ({ close }) => (
  <section className="sidebar_search d-block">
    <h4>Search</h4>
    <TransportationSearchForm onSuccess={close} />
  </section>
);

TransportationSearchFormWrapper.defaultProps = {
  forMobile: false,
};

function TransportationSearchFormWrapper(props) {
  const { forMobile, queryParams, isRoundTrip } = props;
  const { arrivalDate, departureDate, fromLocation, toLocation, pax } = queryParams;

  const roundOrOneWay = isRoundTrip ? '(RoundTrip)' : '(One Way)';

  let dateText = departureDate && formatToShow(departureDate);
  dateText = arrivalDate ? [departureDate, arrivalDate].map(formatToShow).join(' - ') : dateText;

  const searchText = [fromLocation, toLocation].join(' - ');

  return (
    <StaticSearchFormWrapper
      forMobile={forMobile}
      DesktopComponent={renderForDesktop}
      MobileComponent={renderForMobile}
      checkinDate={departureDate}
      checkoutDate={arrivalDate}
      searchText={`${searchText} ${roundOrOneWay}`}
      pax={pax}
      paxText="Passenger"
      dateText={dateText || 'No Dates Selected'}
    />
  );
}

export default injectTransportationSearchParams(TransportationSearchFormWrapper);



// WEBPACK FOOTER //
// ./src/screens/Transportation/Common/TransportationSearchFormWrapper.js